import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from '@/firebase'
import createPersistedState from 'vuex-persistedstate'
// import * as firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    custom: {admin: false},
    admin: null,
    user: null,
    isAdmin:false
  },
  mutations: {
    setUser(state, payload){
      state.user = payload
    },
    clearUser(state){
      state.user = null
    },
    setAdmin(state, isAdmin){
      state.isAdmin = isAdmin
    },
    clearAdmin(state){
      state.isAdmin = false
    }
  },
  
  // actions: {
  //   signIn({ commit }, payload) {
  //     auth.signInWithEmailAndPassword(payload.email, payload.password)
  //       .then(user => {
          
  //           const newUser = {
  //             id: user.uid,
  //             custom: { admin: true }
  //           }
          
          
  //         commit('setAdmin', newUser.custom.admin)
          
  //         commit('setUser', newUser)
            
  //       }) 
  //       .catch(()=>{
  //           alert("Please enter your username and password again.")
  //       })
  //   },
  // },
  
  actions: {
    signIn({ commit }, payload) {
      auth
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((userCredential) => {
          const user = userCredential.user;
  
          // Get the ID token result to check if the user has the 'admin' property set to true in the 'custom' object
          return user.getIdTokenResult().then((idTokenResult) => {
            const isAdmin = idTokenResult.claims.admin === true;
  
            // Create a new user object with the admin status
            const newUser = {
              id: user.uid,
              custom: {
                admin: isAdmin,
              },
            };
  
            // Set the admin status in the store
            commit('setAdmin', isAdmin);
  
            // Set the user in the store
            commit('setUser', newUser);
          });
        })
        .catch(() => {
          alert('Please enter your username and password again.');
        });
    },
  },
  
  getters:{
    admin(state){
      return state.admin
    },
    user(state){
      return state.user
    },
  },
  plugins: [createPersistedState()],

})
